import { VBtn, VBtnToggle } from "vuetify/lib";

export default {
	name: "KDriverBreakToggle",

	props: {
		value: Boolean
	},

	render() {
		return <VBtnToggle mandatory value={this.value}>
			<VBtn
				class={{ "white--text": this.value }}
				color={this.value ? "error" : null}
				depressed={this.value}
				onClick={() => {
					if ( !this.value ) {
						this.$emit( "input", true );
					}
				}}
				ripple={!this.value}
				text={!this.value}
				value={true}
			>
				On Break
			</VBtn>

			<VBtn
				class={{ "white--text": !this.value }}
				color={this.value ? null : "success"}
				depressed={!this.value}
				onClick={() => {
					if ( this.value ) {
						this.$emit( "input", false );
					}
				}}
				ripple={this.value}
				text={this.value}
				value={false}
			>Available</VBtn>
		</VBtnToggle>;
	}
};
